import React, { useEffect, useRef } from 'react';
import Type from 'prop-types';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { ActivityIndicator, EmptyState } from 'components';
import { useTranslation } from 'hooks';
import { usePledges } from 'hooks/api/cascade';
import { useAbortRequest } from 'utils/useAbortRequest';
import { InvoiceList } from './components';

const PaymentScheduleScreen = (props) => {
  const { listHeight } = props;
  const { entityId } = useParams();
  const { abortSignal } = useAbortRequest();
  const { status, isError, error, data } = usePledges(entityId, abortSignal);
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const listRef = useRef(null);

  useEffect(() => {
    if (isError) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  }, [isError]); // eslint-disable-line react-hooks/exhaustive-deps

  const renderInvoices = () => {
    const { invoices } = data;
    const hasInvoices = invoices.length !== 0;

    if (!hasInvoices) {
      return <EmptyState title={t('noPromisesByCurrentCustomer')} />;
    }

    return (
      <InvoiceList ref={listRef} listHeight={listHeight} invoices={invoices} />
    );
  };

  const renderFetchState = () => {
    switch (status) {
      case 'loading':
        return <ActivityIndicator />;
      case 'success':
        return renderInvoices();
      default:
        return null;
    }
  };

  return renderFetchState();
};

PaymentScheduleScreen.propTypes = {
  listHeight: Type.number.isRequired,
};

export default PaymentScheduleScreen;
